import { useTranslation } from 'react-i18next'

import { AirplaneTakeoff } from '@phosphor-icons/react'

import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ParcelOrigin = ({ addressText }) => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <AirplaneTakeoff size={24} /> <Text type="bodyMBold">{t('Origen')}:</Text>{' '}
      <Text type="bodyMRegular">{addressText}</Text>
    </Styles.Container>
  )
}

export default ParcelOrigin
